"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LessonCard = exports.LessonCardDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var utils_1 = require("@shapeable/utils");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_icons_1 = require("../../hooks/use-icons");
var card_1 = require("../../components/elements/card");
var entity_cell_header_1 = require("../../components/entities/entity-cell-header");
var icon_label_1 = require("../../components/elements/icon-label");
var ui_1 = require("@shapeable/ui");
var icons_1 = require("@shapeable/icons");
var use_lang_1 = require("../../hooks/use-lang");
var cls = (0, utils_1.classNames)('program-card');
exports.LessonCardDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var CardStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    margin-bottom: ", ";\n    border: 1px solid ", ";\n    border-radius: ", ";\n  "], ["\n    display: flex;\n    margin-bottom: ", ";\n    border: 1px solid ", ";\n    border-radius: ", ";\n  "])), theme_1.theme.UNIT(6), theme_1.theme.COLOR('line-subtle'), theme_1.theme.UNIT(2))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: 500;\n    line-height: 1.25em;\n    margin-bottom: 0;\n    color: ", ";\n    background: none;\n    margin-top: 0;\n    margin-bottom: ", ";\n\n\n    &:hover {\n      color: ", ";\n    }\n  "], ["\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: 500;\n    line-height: 1.25em;\n    margin-bottom: 0;\n    color: ", ";\n    background: none;\n    margin-top: 0;\n    margin-bottom: ", ";\n\n\n    &:hover {\n      color: ", ";\n    }\n  "])), theme_1.theme.FONT('sans'), theme_1.theme.FONT_SIZE(21), theme_1.theme.COLOR('dark'), theme_1.theme.UNIT(2), theme_1.theme.COLOR('link-hover'))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var IconLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), LabelStyles)
});
var ButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ButtonsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    padding-top: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(2))
});
var FooterStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    padding: 12px;\n  "], ["\n    padding: 12px;\n  "])))
});
// -------- Components -------->
var My = {
  Card: (0, styled_components_1.default)(card_1.Card)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), CardStyles),
  Header: (0, styled_components_1.default)(entity_cell_header_1.EntityCellHeader)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Title: styled_components_1.default.span(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  IconLabel: (0, styled_components_1.default)(icon_label_1.IconLabel)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), IconLabelStyles),
  Buttons: styled_components_1.default.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ButtonsStyles),
  ProgramDetailsButton: (0, styled_components_1.default)(ui_1.Button)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  Footer: styled_components_1.default.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), FooterStyles)
};
var LessonCard = function (props) {
  var className = props.className,
    children = props.children,
    entity = props.entity;
  var _a = entity.presenters,
    presenters = _a === void 0 ? [] : _a,
    hours = entity.hours,
    startDate = entity.startDate,
    endDate = entity.endDate;
  var t = (0, use_lang_1.useLang)();
  var hasPresenters = !!presenters.length;
  var Icons = (0, use_icons_1.useIcons)();
  var definition = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var hasDate = !!startDate || !!endDate;
  var formattedStartDate = startDate ? (0, utils_1.formatDateString)(startDate, 'DD MMM YYYY') : '';
  var formattedEndDate = endDate ? (0, utils_1.formatDateString)(endDate, 'DD MMM YYYY') : '';
  return react_1.default.createElement(My.Card, __assign({}, props, {
    hspace: true,
    space: 5,
    titleMargin: "none",
    to: definition.to(entity.slug),
    className: className
  }), react_1.default.createElement(My.Header, {
    entity: entity,
    badge: ''
  }), react_1.default.createElement(My.Title, null, entity.name), hasPresenters && react_1.default.createElement(My.IconLabel, {
    icon: react_1.default.createElement(Icons.PersonCircle, null)
  }, presenters.map(function (presenter) {
    return presenter.name;
  }).join(', ')), !!hours && react_1.default.createElement(My.IconLabel, {
    icon: react_1.default.createElement(icons_1.UnitIcon, null)
  }, t("".concat(hours, " hour module"))), hasDate && react_1.default.createElement(My.IconLabel, {
    icon: react_1.default.createElement(Icons.Entities.Event, null)
  }, t("Dates:"), " ", formattedStartDate, formattedEndDate && formattedStartDate !== formattedEndDate && " \u2013 ".concat(formattedEndDate)), children);
};
exports.LessonCard = LessonCard;
exports.LessonCard.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;